import $http from '@/plugins/axios'
import { removeNamespace } from '@/utils/helpers'

export const ORGANIZATIONS_TYPES = {
  mutations: {
    SET_LOADING: 'organizations/SET_LOADING',
    SET_PAGED_ORGANIZATIONS: 'organizations/SET_PAGED_ORGANIZATIONS',
    SET_TOTAL_ORGANIZATIONS_COUNT: 'organizations/SET_TOTAL_ORGANIZATIONS_COUNT',
    SET_ORGANIZATION_TABLE_OPTIONS: 'organizations/SET_ORGANIZATION_TABLE_OPTIONS',
    SET_SEARCH_TYPE: 'organizations/SET_SEARCH_TYPE',
    SET_ACTIVE_ORGANIZATION: 'organizations/SET_ACTIVE_ORGANIZATION'
  },
  actions: {
    fetchOrganizationsPaged: 'organizations/fetchOrganizationsPaged',
    changeSearchType: 'organizations/changeSearchType',
    createOrganization: 'organizations/createOrganization',
    fetchOrganization: 'organizations/fetchOrganization',
    updateOrganization: 'organizations/updateOrganization',
    deleteOrganization: 'organizations/deleteOrganization',
    setActiveOrganization: 'organizations/setActiveOrganization'
  }
}

const _types = removeNamespace('organizations', ORGANIZATIONS_TYPES)

const state = () => ({
  loading: false,
  organizationTableOptions: {
    page: 1,
    itemsPerPage: 10,
    keyword: ''
  },
  pagedOrganizations: [],
  totalOrganizationsCount: 0,
  activeOrganization: null
})

const getters = {}

const mutations = {
  [_types.mutations.SET_LOADING] (state, bool) {
    state.loading = bool
  },
  [_types.mutations.SET_PAGED_ORGANIZATIONS] (state, pagedResult) {
    state.pagedOrganizations = pagedResult
  },
  [_types.mutations.SET_TOTAL_ORGANIZATIONS_COUNT] (state, count) {
    state.totalOrganizationsCount = count
  },
  [_types.mutations.SET_ORGANIZATION_TABLE_OPTIONS] (state, options) {
    state.organizationTableOptions = options
  },
  [_types.mutations.SET_SEARCH_TYPE] (state, type) {
    state.organizationTableOptions.searchType = type
  },
  [_types.mutations.SET_ACTIVE_ORGANIZATION] (state, org) {
    state.activeOrganization = org
  }
}

const actions = {
  [_types.actions.fetchOrganizationsPaged] ({ state, commit }) {
    commit(_types.mutations.SET_LOADING, true)
    const { itemsPerPage, page, keyword, bakerFirstStatus } = state.organizationTableOptions
    return $http().get(`admin/organizations/paged`, {
      params: {
        skipCount: (page - 1) * itemsPerPage,
        maxResultCount: itemsPerPage,
        keyword,
        bakerFirstStatus
      }
    })
      .then((res) => {
        const { items, totalCount } = res
        commit(_types.mutations.SET_PAGED_ORGANIZATIONS, items)
        commit(_types.mutations.SET_TOTAL_ORGANIZATIONS_COUNT, totalCount)
      })
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  },
  [_types.actions.changeSearchType] ({ commit }, searchType) {
    commit(_types.mutations.SET_SEARCH_TYPE, searchType)
  },
  [_types.actions.createOrganization] ({ dispatch, commit }, organization) {
    commit(_types.mutations.SET_LOADING, true)
    return $http().post('admin/organizations', organization)
      .then(async (res) => {
        await dispatch(_types.actions.fetchOrganizationsPaged)
        commit(_types.mutations.SET_ACTIVE_ORGANIZATION, res)
        return res
      })
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  },
  [_types.actions.updateOrganization] ({ dispatch, commit }, organization) {
    commit(_types.mutations.SET_LOADING, true)
    return $http().patch(`admin/organizations/${organization.id}`, organization)
      .then(async (res) => {
        await dispatch(_types.actions.fetchOrganizationsPaged)
        commit(_types.mutations.SET_ACTIVE_ORGANIZATION, res)
        return res
      })
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  },
  [_types.actions.deleteOrganization] ({ dispatch, commit }, organization) {
    commit(_types.mutations.SET_LOADING, true)
    return $http().delete(`admin/organizations/${organization.id}`)
      .then(async () => {
        await dispatch(_types.actions.fetchOrganizationsPaged)
        commit(_types.mutations.SET_ACTIVE_ORGANIZATION, null)
      })
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  },
  [_types.actions.fetchOrganization] ({ commit }, id) {
    commit(_types.mutations.SET_LOADING, true)
    return $http().get(`admin/organizations/${id}`)
      .then((res) => {
        commit(_types.mutations.SET_ACTIVE_ORGANIZATION, res)
        return res
      })
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  },
  [_types.actions.setActiveOrganization] ({ commit }, organization) {
    commit(_types.mutations.SET_ACTIVE_ORGANIZATION, organization)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
